import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { installTemplateHelpers } from './app/templateHelpers';
import './styles/base.css';
import { registerServiceWorker } from './pwa/register';

const app = createApp(App);
installTemplateHelpers(app);
app.use(createPinia()).mount('#app');
// The public read-only viewer (/s/{token}) is a one-off unauthenticated page: no service worker registration.
if (!/^\/s\//.test(location.pathname)) registerServiceWorker();
